export const fmtMoney = (locale, value, currency) => {
  try {
    const s = new Intl.NumberFormat(locale, { style: "currency", currency, currencyDisplay: "narrowSymbol", maximumFractionDigits: value % 1 ? 2 : 0 }).format(value || 0);
    return `\u2068${s}\u2069`;
  } catch {
    return `${value} ${currency}`;
  }
};

export const fmtTotals = (locale, totals) => {
  const entries = Object.entries(totals || {}).filter(([, v]) => v);
  return entries.length ? entries.map(([c, v]) => fmtMoney(locale, v, c)).join(" · ") : null;
};

export const sumByCurrency = (deals) => deals.reduce((acc, d) => (d.value ? { ...acc, [d.currency]: (acc[d.currency] || 0) + d.value } : acc), {});
